import React, { useEffect, useState } from "react";
import { Card, Col, Row, Switch, message } from "antd";
import { hoursRestrictionModel } from "../../constants";
import { TimeRangePicker } from "../../../../components/DatePicker";

const OperatingHours = ({ widget, handleWidgetChange }) => {
  const [hoursRestriction, setHoursRestriction] = useState({
    ...hoursRestrictionModel,
  });

  const handleSave = () => {
    if (hoursRestriction?.enabled && hoursRestriction?.values?.length === 0) {
      message.error(`Please enter time`);
      return;
    }
    handleWidgetChange({ hoursRestriction, id: widget.id });
  };

  useEffect(() => {
    if (widget.hoursRestriction)
      setHoursRestriction({ ...widget.hoursRestriction });
    else setHoursRestriction({ ...hoursRestrictionModel });
  }, [widget.id, widget.hoursRestriction]);

  return (
    <Card className="setting_wrapper">
      <Row className="center_items setting_label">
        <Col span={12}>
          <h4 className="p-color">Operating Hours</h4>
        </Col>
        <Col span={12} className="action">
          <div style={{ textAlign: "end" }} className="flex_items">
            <Switch
              name="status"
              id="custom-switch"
              checked={hoursRestriction.enabled}
              onChange={(checked) => {
                if (!checked) setHoursRestriction({ ...hoursRestrictionModel });
                else
                  setHoursRestriction({
                    ...hoursRestriction,
                    enabled: checked,
                  });
              }}
            />
          </div>

          <div onClick={handleSave} className="action_btn ml-2">
            <i className="fa-regular fa-floppy-disk "></i>
            <span>Save</span>
          </div>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <TimeRangePicker
            disabled={!hoursRestriction.enabled}
            className="full_width"
            order={false}
            format={"HH:mm"}
            allowClear={false}
            onChange={(objectValue, value) => {
              setHoursRestriction({ ...hoursRestriction, values: value });
            }}
            value={
              hoursRestriction?.values && hoursRestriction?.values.length > 0
                ? [
                    new Date(`2023-01-01 ${hoursRestriction?.values[0]}`),
                    new Date(`2023-01-01 ${hoursRestriction?.values[1]}`),
                  ]
                : null
            }
          />
        </Col>
      </Row>
    </Card>
  );
};

export default React.memo(OperatingHours);
